import { useEffect } from "react";

// Lightweight SEO: manages document title, meta description, canonical, OG,
// and optional JSON-LD structured data per page. No external dependency.
export default function Seo({ title, description, path = "", image, jsonLd, noindex = false }) {
  useEffect(() => {
    const fullTitle = title ? `${title} · DuckTheBugs` : "DuckTheBugs — The homeowner's guide to bugs, bites & backyard pests";
    document.title = fullTitle;

    const setMeta = (selector, attr, key, value) => {
      if (!value) return;
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", value);
    };

    setMeta('meta[name="description"]', "name", "description", description);
    setMeta('meta[property="og:title"]', "property", "og:title", fullTitle);
    setMeta('meta[property="og:description"]', "property", "og:description", description);
    if (image) setMeta('meta[property="og:image"]', "property", "og:image", image);

    const canonicalHref = `https://duckthebugs.com${path}`;
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonicalHref);

    // Keep private pages (admin) out of search results.
    let robots = document.head.querySelector('meta[name="robots"]');
    if (noindex) {
      if (!robots) {
        robots = document.createElement("meta");
        robots.setAttribute("name", "robots");
        document.head.appendChild(robots);
      }
      robots.setAttribute("content", "noindex, nofollow");
    } else if (robots) {
      robots.remove();
    }

    let script = document.getElementById("page-jsonld");
    if (jsonLd) {
      if (!script) {
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = "page-jsonld";
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(jsonLd);
    } else if (script) {
      script.remove();
    }
  }, [title, description, path, image, jsonLd, noindex]);

  return null;
}
